import React, { useEffect } from "react";

import { Outlet } from "react-router";
import { useFirebaseAuth } from "@/contexts/UserProfileContext/UserProfileContext";
import { useRedirect } from "@/contexts/RedirectContext";

export default function PublicOnlyRoute({ defaultRedirect = "/account" }: { defaultRedirect?: string }) {
    const { user, isAnonymous, isAuthLoading, isUserProfileLoading } = useFirebaseAuth();
    const { triggerRedirect } = useRedirect();

    const shouldRedirect = !isAnonymous && user && !isAuthLoading && !isUserProfileLoading;

    useEffect(() => {
        if (shouldRedirect) {
            // React doesn't like updating state during render, so we use useEffect
            triggerRedirect(defaultRedirect);
        }
    }, [defaultRedirect, shouldRedirect, triggerRedirect]);

    // TODO: Show loading screen of child while deciding to redirect

    return <Outlet />;
}
